import axios from "axios";
import * as types from "../mutation-types";
import { getProjectByProId } from "./projects";
import { getEventIndexById } from "./fullcalendar";
import logger from "~/utilities/logger";

// state
export const state = {
  company_list: [],
  company_select: null,
  the_id: null,
};

// getters
export const getters = {
  company_list: (state) => state.company_list,
  check_list: (state) => state.company_list !== null,
  company_select: (state) => state.company_select,
  the_id: (state) => state.the_id,
};

//utils
export const getCompanyIndexById = (state, comId) =>
  state.company_list.findIndex(
    (company) => company.com_id.toString() === comId.toString()
  );
export const getCompanyByComId = (state, comId) =>
  state.company_list.find(
    (company) => company.com_id.toString() === comId.toString()
  );

// mutations
export const mutations = {
  [types.ADD_COMPANY](state, company)
  {
    return state.company_list.push(company);
  },
  [types.ADD_COMPANY_FAILURE](state, error) {},

  [types.FETCH_COMPANIES](state, { company_list })
  {
    return (state.company_list = company_list);
  },

  [types.FETCH_COMPANIES_FAILURE](state)
  {
    logger.error("FETCH_COMPANIES_FAILURE");
  },

  [types.FETCH_COMPANY](state, { company_select })
  {
    return (state.company_select = company_select);
  },

  [types.FETCH_COMPANY_FAILURE](state, { error })
  {
    logger.error("FETCH_COMPANY_FAILURE", error);
  },

  [types.SELECT_COMPANY](state, { com_id })
  {
    let theSelect = getCompanyByComId(state, com_id);
    logger.log("store.SELECT_COMPANY", theSelect);
    return (state.company_select = theSelect);
  },

  [types.DESELECT_COMPANY](state)
  {
    return (state.company_select = null);
  },

  [types.DELETE_COMPANY](state, { com_id })
  {
    logger.log("store.DELETE_COMPANY", state, com_id);
    const index = getCompanyIndexById(state, com_id);
    if (index === -1)
    {
      return console.warn(`Unable to delete company (id ${com_id})`);
    }
    return state.company_list.splice(index, 1);
  },

  [types.UPDATE_COMPANY](state, { payload })
  {
    // state.company_select = payload.cou_name;
  },

  [types.SET_COMPANY_ID](state, { id })
  {
    return (state.the_id = id);
  },

  [types.SEARCH_COMPANIES](state, { company_list })
  {
    return (state.company_list = company_list);
  },

  [types.SEARCH_COMPANIES_FAILURE](state, error)
  {
    logger.error("SEARCH_COMPANIES_FAILURE", error);
  },
};

// actions
export const actions = {
  async addCompany({ commit }, company)
  {
    try
    {
      logger.log("store.addCompany", "/api/companies", company);
      const { data } = await axios.post("/api/companies", company);
      if (data.status && data.status === "success")
      {
        logger.log("store.addCompany rsp", data);
        return commit(types.ADD_COMPANY, data.data);
      } else
      {
        return commit(types.DELETE_COMPANY_FAILURE, data);
      }
    } catch (e)
    {
      logger.log("DELETE_COMPANY_FAILURE", e);
      return commit(types.DELETE_COMPANY_FAILURE, e);
    }
  },

  async getCompanies({ commit }, options)
  {
    try
    {
      let paginate = options && options.paginate ? options.paginate : 10000;
      let extraOptions =
        options && options.extra_options ? options.extra_options : "";
      let format = options && options.format ? options.format : "minimal";

      const { data } = await axios.get(
        `/api/companies?paginate=${paginate}${extraOptions}`
      );
      logger.log("store.getCompanies", data);
      return commit(types.FETCH_COMPANIES, { company_list: data.data });
    } catch (e)
    {
      logger.error("store.getCompanies error", e);
      return commit(types.FETCH_COMPANIES_FAILURE);
    }
  },

  async getCompany({ commit, dispatch }, payload)
  {
    if (!payload.com_id) return;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    let format = payload && payload.format ? payload.format : "minimal";
    try
    {
      const { data } = await axios.get(`/api/companies/${payload.com_id}`);
      logger.log("store.getCompany rsp", data);
      return commit(types.FETCH_COMPANY, { company_select: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_COMPANY_FAILURE, { error: e });
    }
  },

  async deleteCompany({ commit, dispatch }, payload)
  {
    if (!payload.com_id) return;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    try
    {
      const { data } = await axios.delete(
        `/api/companies/${payload.com_id}${extraOptions}`
      );
      logger.log("store.deleteCompany rsp", data);
      return commit(types.DELETE_COMPANY, { com_id: payload.com_id });
    } catch (e)
    {
      logger.log(e);
      return commit(types.DELETE_COMPANY_FAILURE, { error: e });
    }
  },

  async updateCompany({ commit, dispatch }, payload)
  {
    try
    {
      const { data } = await axios.put(
        `/api/companies/${payload.com_id}`,
        payload
      );
      logger.log("store.updateCompany", data);
      return commit(types.UPDATE_COMPANY, { payload: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_COMPANY_FAILURE, { error: e });
    }
  },

  setCompanyID({ commit, dispatch }, id)
  {
    return commit(types.SET_COMPANY_ID, { id: id });
  },

  async searchCompanies({ commit }, query)
  {
    try
    {
      const { data } = await axios.get(`/api/companies?search=${query}`);
      logger.log("store.searchCompanies", data);
      return commit(types.SEARCH_COMPANIES, { company_list: data.data.data });
    } catch (e)
    {
      logger.error("store.searchCompanies error", e);
      return commit(types.SEARCH_COMPANIES_FAILURE, e);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
